<template>
  <div class="selectedPuri">
    <template v-if="uris.length > 0">
      <div class="card">
        <div class="body">
          <div :class="[
            {'selectedPuri__one': uris.length === 1},
            {'selectedPuri__two': uris.length === 2},
            {'selectedPuri__three': uris.length === 3},
            {'selectedPuri__four': uris.length === 4}
          ]">
            <div  v-for="(list, index) in uris" :key="index" class="cell">
              <img class="thumbnail" v-lazy="list">
              <div v-if="selectedContents[index].hasgraff && !selectedContents[index].surpriseShot2" class="graffity" />
              <div v-if="selectedContents[index].surpriseShot || selectedContents[index].surpriseShot2" class="surprise" />
            </div>
          </div>
        </div>
        <div class="footer" :style="'background-image: url(' + getImg(arcadeLogoImg) + ')'">
            {{ createDateStr }}
        </div>
    </div>
    </template>
  </div>
</template>

<script>
import Screen from '../mixins/screen'
import Protobuf from '../mixins/protobuf'

const { toJpegURI, ymd, daysLeft } = require('../assets/js/util')

export default {
  name: "PuriContentsBottom",
  mixins: [Protobuf, Screen],
  props: {
    selectedContents: {
      type: Array,
      require: true,
    },
    limitDate: {
      type: Number,
      required: true
    },
    createDate: {
      type: Number,
      required: true
    },
    membershipGrade: {
      type: Number,
      required: true
    },
    arcadeLogoImg: {
      type: String,
      require: true,
    }
  },
  mounted(){
  },
  computed: {
    uris() {
      return this.selectedContents.map(c => toJpegURI(c.bytes))
    },
    limitDateStr() {
      return daysLeft(this.limitDate)
    },
    createDateStr() {
      return ymd(this.createDate).join('.')
    }
  },
  methods: {
    getImg(img) {
      return process.env.VUE_APP_STATIC_CONTENT_SERVER_URL + img
    },
  }
}
</script>

<style lang="scss" scoped>
.selectedPuri {
  position: relative;
  width: 100%;
  &__one,
  &__two,
  &__three,
  &__four {
    display: flex;
    width: 100%;
    .cell {
      position: relative;
      .thumbnail {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .graffity {
        position: absolute;
        width: 35px;
        height: 35px;
        bottom: 1px;
        right: 1px;
        background-image: url(../assets/Png/Album/Album_Puri_Graffiti.png);
        background-size: contain;
        z-index: 10;
      }
      .surprise {
        position: absolute;
        width: 35px;
        height: 35px;
        top: 1px;
        right: 1px;
        background-image: url(../assets/Png/Album/Album_PuriMotto.png);
        background-size: contain;
        z-index: 10;
      }
    }
  }
  &__one,
  &__two,
  &__three {
    justify-content: center;
    align-items: center;
  }
  &__one {
    margin: 0 auto;
    .cell {
      width: calc(50% - 2.5px);
      height: 193px;
      margin: 0;
    }
  }
  &__two {
    .cell {
      width: calc(50% - 2.5px);
      height: 193px;
      &:first-child {
        margin-right: 5px;
      }
    }
  }
  &__three {
    .cell {
      width: calc(33% - 3.3px);
      height: 125px;
      margin-left: 5px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  &__four {
    flex-wrap: wrap;
    height: fit-content;
    .cell {
      width: calc(50% - 2.5px);
      height: 193px;
      &:nth-of-type(2n){
        margin-left: 5px;
      }
      &:nth-of-type(3n),
      &:nth-of-type(4n){
        margin-top: 5px;
      }
    }
  }
  img {
    width: 100%;
    height: auto;
  }
  .card {
    background-color: #fff;
    border-radius: 8px;
    padding: 10px 20px;
    border: 1px solid #E1DADB;
  }

  .header {
    padding-left: 40px;
    font-size: 12px;
    color: #F63C5B;
    background-image: url(../assets/Png/Common/ic_exclamation_pink.png);
    background-size: contain;
    background-position: 10px;
  }

  .body {
    margin: 10px 0;
  }
  .footer {
    padding: 2px 0;
    text-align: right;
    font-size: 10px;
    color: #373737;
    background-size: contain;
    background-position: 77%;
    &.romakyun      { background-image: url(../assets/Png/Common/pridl_logo_small_romakyun.png); }
    &.bepiu         { background-image: url(../assets/Png/Common/PriDl_logo_small_Bepiu.png); }
    &.ROMAPI        { background-image: url(../assets/Png/Common/pridl_logo_small_romapi.png); }
    &.lalamee       { background-image: url(../assets/Png/Common/Pridl_logo_small_lalamee.png); }
    &.meityromantic { background-image: url(../assets/Png/Common/image_logo_meiroma_black_small.png); }
    &.fiz2          { background-image: url(../assets/Png/Common/image_logo_fiz2_black_small.png); }
    &.fiz           { background-image: url(../assets/Png/Common/image_logo_fiz_black_small.png); }
  }
}

.smallText {
    margin: 20px 15px 0;
    font-size: 12px;
}
</style>
